import React from 'react';
import { css } from 'styled-components';
import i18n from 'i18n';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import { NavLink } from 'react-router-dom';

const FooterNav = ({ className }) => (
  <nav className={className}>
    <ul>
      <a href="https://hoshinoresorts.com/jp/">
        <li>{i18n.t('common:footer.officialSite')}</li>
      </a>
      <a href="https://hoshinoresorts.com/ja/sp/privacypolicy/">
        <li>{i18n.t('common:footer.personalInfo')}</li>
      </a>
      <NavLink to="/terms">
        <li>{i18n.t('common:footer.termsOfService')}</li>
      </NavLink>
      <NavLink to="/specified">
        <li>
          {i18n.t('common:footer.aboutSpecifiedCommercialTransactionLaw')}
        </li>
      </NavLink>
    </ul>
  </nav>
);

const commonStyle = css`
  width: 100%;

  ul {
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  li {
    font-family: serif;
    color: ${Colors.black1};
    ${FontStyles.text10};
  }

  a {
    text-decoration: none;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  ul {
    width: 100%;
    list-style: none;
    text-align: center;
  }

  li {
    display: inline-block;
    margin: 0 14.5px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  text-align: center;

  ul {
    &: last-child {
      margin-bottom: 28px;
    }
  }

  li {
    ${FontStyles.text8};
    margin-bottom: 16px;
  }
`;

export default applyStyles(FooterNav)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/Footer/components/FooterNav.js